import request from "@/utils/request";

// 列表(主数据列表)
export function loadStoreInfoCollectPlanListDataApi(data) {
    return request({
      url: "web/storeInfoCollectPlan/listData",
      method: "post",
      data
    });
  }
// 导出
export function loadStoreInfoCollectPlanExportDataApi(data) {
  return request({
    url: "web/storeInfoCollectPlan/exportData",
    method: "post",
    data
  });
}
// 根据条件查询计划条数
export function loadStoreInfoCollectPlanListDataCountApi(data) {
  return request({
    url: "web/storeInfoCollectPlan/listDataCountByPage",
    method: "post",
    data
  });
}
// 统计列表(主数据列表)
export function loadStoreInfoCollectPlanListDataByStatisticsApi(data) {
  return request({
    url: "web/storeInfoCollectPlan/listDataByStatistics",
    method: "post",
    data
  });
}
// 统计导出
export function loadStoreInfoCollectPlanExportDataByStatisticsApi(data) {
return request({
  url: "web/storeInfoCollectPlan/exportDataByStatistics",
  method: "post",
  data
});
}
// 批量忽略计划
export function updateBatchIgnoreStoreInfoCollectPlanApi(data) {
return request({
  url: "web/storeInfoCollectPlan/updateBatchIgnore",
  method: "post",
  data
});
}